import React from 'react';
import { trackingServiceNewsLetterEvent } from '../../Services/Tracking.service';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { post } from '../../Services/http';

interface newsletterRegistrationProps {
  embeddedForm: string;
}

const NewsletterRegistration = ({
  embeddedForm,
}: newsletterRegistrationProps) => {
  const { currency } = useTypedSelector((state) => state.cart);

  window.addEventListener('klaviyoForms', function (e: CustomEvent) {
    if (e.detail && e.detail.type == 'submit') {
      post('/api/newsletter/subscribed', {})
        .then((response) => {
          if (response.ok) {
            trackingServiceNewsLetterEvent(currency);
          }
        })
        .catch((error) => {
          console.error(
            'An error occurred while subscribing to newsletter:',
            error
          );
        });
    }
  });

  return <div dangerouslySetInnerHTML={{ __html: embeddedForm }} />;
};

export default NewsletterRegistration;
